//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentPreviewer from "./document-previewer";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import GenericModal from "@Shared/components/modals/generic-modal";
import FileManagementMixin from "@Shared/utils/application-mixins/file-management-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentPreviewModal",
  components: {
    GenericModal,
    DocumentPreviewer,
    SimpleButton
  },
  mixins: [FileManagementMixin],
  props: {
    fileName: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    documentIsDownloading: {
      type: Boolean,
      default: false
    },
    allowDownload: {
      type: Boolean,
      default: true
    },
    modalDialogSize: {
      type: String,
      default: "lg"
    },
    headerCloseButton: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingIFrame: true
    };
  },
  computed: {
    fileExtension() {
      return this.fileName.split(".").pop();
    }
  },
  methods: {
    handleDownload() {
      this.$emit("download-document");
    },
    show() {
      this.$showModal();
    },
    hide() {
      this.$hideModal();
    },
    handleHide() {
      this.$emit("hide");
    }
  }
});